/**
 * Impact-detection types.
 * Mirrors backend models.py ImpactDetectionSettings / ImpactEvent and the
 * RTDB nodes devices/{id}/config/impactDetection and devices/{id}/impactEvents
 * (see contracts/firebase-schema.md §2.3 and §12).
 */

export type ImpactSensitivity = 'low' | 'medium' | 'high';

export interface ImpactDetectionSettings {
  enabled: boolean;
  actionId?: string | null; // references an action; may dangle after action delete
  sensitivity: ImpactSensitivity;
  overlayDurationMinutes: number; // 1-180
  updatedAt?: number | null;
  updatedBy?: string | null;
}

export interface ImpactDetectionSettingsUpdate {
  enabled?: boolean;
  actionId?: string; // '' clears the configured action
  sensitivity?: ImpactSensitivity;
  overlayDurationMinutes?: number;
}

export interface ImpactEvent {
  id: string;
  timestamp: number; // epoch ms
  peak_magnitude: number; // m/s²
  sensitivity: string;
  action_triggered: boolean;
}

export const DEFAULT_IMPACT_DETECTION_SETTINGS: ImpactDetectionSettings = {
  enabled: false,
  actionId: null,
  sensitivity: 'medium',
  overlayDurationMinutes: 5,
};
